import { ClientRow, CustomerRow } from "./clients.defs";

export class Client {

	name: string;
    id: number;
    lastBarber: string;

	constructor(
		private _client: ClientRow,
		public number: CustomerRow,
	) {
		this.load(_client);
	}

	load(c: ClientRow) {
		this.name = c.Name ? c.Name.toLowerCase() : '?';
        this.id = c.id;
        this.lastBarber = c.Barber || '';
	}

	get tel() {
		return this.number.NUMBER;
	}

	get customerId() {
		return this.number.id;
	}

}
